import React from "react";

export const TextSection = ({
  id,
  testId,
  eyebrow,
  title,
  titleAccent,
  body,
  variant = "default",
}) => {
  const muted = variant === "muted";
  return (
    <section
      id={id}
      data-testid={testId}
      className={`relative py-24 lg:py-32 ${muted ? "bg-soft" : "bg-page"}`}
    >
      <div className="mx-auto max-w-5xl px-5 lg:px-10 text-center">
        {eyebrow && (
          <div className="flex justify-center">
            <span className="chip">
              <span className="chip-dot" />
              <span className="font-mono text-[12px] text-ink-200">
                {eyebrow}
              </span>
            </span>
          </div>
        )}

        <h2
          className="mt-8 headline mx-auto max-w-4xl"
          style={{ fontSize: "clamp(1.85rem, 4.2vw, 3.4rem)" }}
        >
          {title}
          {titleAccent && (
            <>
              {" "}
              <em>{titleAccent}</em>
            </>
          )}
        </h2>

        {body && (
          <div className="mt-8 max-w-2xl mx-auto space-y-5">
            {body
              .split("\n\n")
              .map((p, i) => (
                <p
                  key={i}
                  className="text-[16.5px] lg:text-[17px] leading-[1.75] text-ink-200/75 font-light"
                >
                  {p}
                </p>
              ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default TextSection;
